import { type DealerAccessFactsAnswer, dealerAccessFactsAnswerReadSchema } from "@hakili/contracts";
import { t } from "@hakili/i18n";

/**
 * `P1-CNW-064`: the live answer of `GET /api/v1/dossiers/{id}/dealer-access-facts` (#901's door), parsed by the contract's READ twin (A48: no hand-written reader). An answer the schema refuses is
 * « Réponse inattendue du serveur. », never a half-drawn panel.
 */
export function parseDealerAccessFacts(answer: unknown): DealerAccessFactsAnswer {
  const parsed = dealerAccessFactsAnswerReadSchema.safeParse(answer);
  if (!parsed.success) throw new Error(t("common.error.reponseInattendue"));
  return parsed.data;
}
